import React, { FC } from 'react'
import DocumentTitle from 'react-document-title'
import { Box, Typography } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import CarrierApplicationForm from '../components/CarrierApplicationForm'
import { CarrierLookupForm } from '../components/CarrierLookupForm/CarrierLookupForm'

export interface INewCarrierApplicationProps {}

const NewCarrierApplication: FC<INewCarrierApplicationProps> = () => {
  const isHighwayCarrierApplicationFlowEnabled = useFeatureFlag('highwayCarrierApplicationFlow')

  return (
    <section className='container-fluid pt8'>
      <DocumentTitle title='New Carrier Application'>
        <section className='flex flex-column pa6'>
          <Box mb={2}>
            <Typography variant='h2'>New Carrier Application</Typography>
          </Box>
          {isHighwayCarrierApplicationFlowEnabled ? (
            <CarrierLookupForm />
          ) : (
            <CarrierApplicationForm />
          )}
        </section>
      </DocumentTitle>
    </section>
  )
}

export default NewCarrierApplication
